import capitalize from '@material-ui/core/utils/capitalize';

export { capitalize };
